import React, { useEffect } from 'react';
import { useBrazeContentCards } from '../../../hooks';
import { BrazeContentCard } from './BrazeContentCard';
import type { BrazeCardEvent } from './types';

export const BrazeContentCardList: React.FC = () => {
  const brazeContentCards = useBrazeContentCards();

  useEffect(() => {
    // card list shows all cards immediately
    // so, we log all that
    brazeContentCards.cards?.forEach(card => {
      brazeContentCards.markCardAsViewed?.({ card });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [brazeContentCards.cards]);

  const handlePress = (e: BrazeCardEvent) => {
    brazeContentCards.selectCard(e);
  };

  return (
    <React.Fragment>
      {brazeContentCards.cards.map(card => (
        <BrazeContentCard
          key={card.id}
          card={card}
          onPress={handlePress}
        />
      ))}
    </React.Fragment>
  );
};
